
const urlStore = {
  state: {
    url: process.env.VUE_APP_API_URL,
    urlOverride:null
  },
  actions: {
    setURL (context, url) {
      context.commit('setURL', url)
    },
    setURLOverride (context, url) {
      context.commit('setURLOverride', url)
    },
  },
  mutations: {
    setURL (state, url) {
      state.url = url
      localStorage.setItem('url', url)
      // add to localstorage
    },
    setURLOverride (state, url) {
      state.urlOverride = url
    }
  },
  getters: {
    apiBaseURL(state) {
      if(localStorage.getItem('url')){
        return localStorage.getItem('url')
      } else if(state.urlOverride){
        return state.urlOverride
      } else {
        return state.url
      }
    }
  }
}

export default urlStore
